/* unplugin-vue-components disabled */import { render } from "./WallSVG.vue?vue&type=template&id=c579bc22"
import script from "./WallSVG.vue?vue&type=script&lang=js"
export * from "./WallSVG.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__